import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import App from './App.vue'

import CMCard from './components/CMCard.vue'
import BGATermsOfUse from './components/BGATermsOfUse.vue'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {max_value, min_value, required} from 'vee-validate/dist/rules'
import VueFilterDateFormat from 'vue-filter-date-format'
import JsonExcel  from './components/JsonExcel.vue'

import {bus} from "@/event-bus"


Vue.config.productionTip = false
if (Vue.config.devtools) {
    Vue.prototype.$hostname = process.env.VUE_APP_DATA_HOSTNAME
} else {
    Vue.prototype.$hostname = process.env.VUE_APP_DATA_HOSTNAME
}

console.log("%c IDA CARRIER MATRIX "+process.env.VUE_APP_VERSION+" %c \n\n Built with ❤ by ApisProductions.com!", "color:#091b59; background-color:#fff; padding: 4px; font-size: 20px", "")

Vue.use(vueCustomElement)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.component('cm-card', CMCard)
Vue.component('bga-terms-of-use', BGATermsOfUse)
Vue.use(VueTheMask)
Vue.use(money, {precision: 0, masked: false})
Vue.use(VueFilterDateFormat)
Vue.use(bus)

extend('required', required);
extend('min_value', min_value);
extend('max_value', max_value);
extend('date', {
    validate: value =>
        /((0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d)/.test(value),
    message: 'Date must be in mm/dd/yyyy format'
});

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.component("downloadExcel", JsonExcel)

Vue.customElement('carrier-matrix', App)